import { render, staticRenderFns } from "./EvaluateRecords.vue?vue&type=template&id=f8382442&scoped=true&"
import script from "./EvaluateRecords.vue?vue&type=script&lang=js&"
export * from "./EvaluateRecords.vue?vue&type=script&lang=js&"
import style0 from "./EvaluateRecords.vue?vue&type=style&index=0&id=f8382442&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8382442",
  null
  
)

export default component.exports